import { render, staticRenderFns } from "./BasicInput.vue?vue&type=template&id=56bd8612&scoped=true&"
import script from "./BasicInput.vue?vue&type=script&lang=js&"
export * from "./BasicInput.vue?vue&type=script&lang=js&"
import style0 from "./BasicInput.vue?vue&type=style&index=0&id=56bd8612&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd8612",
  null
  
)

export default component.exports